import { AlertType, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import React, { useEffect, useState } from 'react'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { RiEdit2Fill } from 'react-icons/ri'
import { VendasService } from '../../Pages/Vendas/vendasService'
import { Funcoes } from '../../Utils/Funcoes'

type Props = {
    visible: boolean
    id_Venda: any
    numItem?: any
    atualizarDadosItem?: (itens: any) => void
    closeModalEvent?: () => void
}

export const ModalEditItemVenda = React.memo(({ visible, id_Venda, numItem, atualizarDadosItem, closeModalEvent }: Props) => {

    const [visibleMsg, setVisibleMsg] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    const [loading, setLoading] = useState(false)

    const [item, setItem] = useState('0')
    const [descricao, setDescricao] = useState('')
    const [qtd, setQtd] = useState('0')
    const [precoUnit, setPrecoUnit] = useState('0')
    const [precoTotal, setPrecoTotal] = useState('0')
    const [obsItem, setObsItem] = useState('')
    const [idGrade, setIdGrade] = useState('0')
    const [codBarra, setCodBarra] = useState('')

    useEffect(() => {

        if (visible) {

            getAttributes()

            let modal = document.getElementById('modal_edit_item_venda')
            let modalContent = document.getElementById('modal_content_edit_item_venda')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]')
                    modalContent.classList.add('mt-36')
                }
            }

        } else {

            setVisibleMsg(false)
            setItem('0')
            setDescricao('')
            setQtd('')
            setPrecoUnit('0')
            setPrecoTotal('0')
            setObsItem('')

            let modal = document.getElementById('modal_edit_item_venda')
            let modalContent = document.getElementById('modal_content_edit_item_venda')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]')
                    modalContent.classList.remove('mt-36')
                }
            }
        }

    }, [visible])

    useEffect(() => {
        calcularVlTotal()
    }, [precoUnit, qtd])

    const getAttributes = async () => {
        setLoading(true)
        try {

            const attr = await VendasService.GetAttributesEdit(id_Venda, numItem)

            if (attr.data) {

                setItem(attr.data.nitem || '0')
                setDescricao(attr.data.desc_prod || '')
                setQtd(attr.data.qtde || '0')
                setPrecoUnit(attr.data.vl_unit || '0')
                setPrecoTotal(attr.data.vl_tot || '0')
                setObsItem(attr.data.observacao || '')
                setIdGrade(attr.data.id_grade || '0')
                setCodBarra(attr.data.cod_barra || '')

            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }
    }

    const qtdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setQtd(e.target.value.replace(/[^0-9]/g, ''))
    }

    const precoUnitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPrecoUnit(Funcoes.MaskMoney(e.target.value))
    }

    const obsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setObsItem(e.target.value)
    }

    const calcularVlTotal = () => {
        setPrecoTotal(Funcoes.numberFormat(parseFloat(precoUnit) * parseInt(qtd)))
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    const salvarVendaItem = async () => {

         setLoading(true)
        setVisibleMsg(false)

        try {

            let itens: any = {
                id_venda: id_Venda,
                cod_barra: codBarra.replace(/^\d+\*/, ""),
                qtde: qtd,
                vl_unit: parseFloat(precoUnit),
                idGrade: idGrade,
                numItem: item,
                obsItem: obsItem
            }

            const resp = await VendasService.SaveItemVenda(itens)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Código de barras não encontrado")

            } else {
                 
                let itensLista: any = {
                    id_venda: id_Venda,
                    id_produto: resp.data.v_item.id_produto,
                    desc_prod: resp.data.v_item.desc_prod,
                    cod_barra: codBarra.replace(/^\d+\*/, ""),
                    qtde: qtd,
                    vl_unit: resp.data.v_item.vl_unit || 0,
                    vl_custo: resp.data.v_item.vl_custo || 0,
                    vl_desc: resp.data.v_item.vl_desc || 0,
                    vl_tot: resp.data.v_item.vl_tot || 0,
                    observacao: resp.data.v_item.observacao || '',
                    numItem: item,
                    
                    totalItems: resp.data.venda.qtd_itens,
                    subTotal: resp.data.venda.vl_liquido,
                    subTotalCopy: resp.data.venda.vl_liquido
                }

                if(atualizarDadosItem){
                    atualizarDadosItem(itensLista || {})
                }

            }


        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao lançar o produto na venda")

        } finally {

            setLoading(false)

        }
    }

    return (

        <div id="modal_edit_item_venda" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_edit_item_venda" className={`relative flex flex-col w-[90%] xl:w-[70%] 2xl:w-[60%] h-[350px] bg-white dark:bg-slate-600 rounded-lg mt-[-500px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <RiEdit2Fill size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-200`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>{`Editar - Item - ${descricao || ''}`}</span>
                </div>

                <div className={`absolute top-[70px] flex flex-row w-full`}>

                    <div className={`grid grid-cols-12 gap-4 p-4`}>

                        <div className={`relative col-span-2`}>
                            <input id="nItemEdit" className={`${classInput} ${classInputDark} cursor-not-allowed`} type="text" placeholder=' ' autoComplete="off" value={item} disabled={true} readOnly />
                            <label htmlFor="nItemEdit" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Item</label>
                        </div>

                        <div className={`relative col-span-10`}>

                            <input id="descEdit" className={`${classInput} ${classInputDark} cursor-not-allowed`} type="text" placeholder=' ' autoComplete="off" value={descricao} disabled={true} readOnly />
                            <label htmlFor="descEdit" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Descrição</label>
                        </div>

                        <div className={`relative col-span-4`}>
                            <input id="qtdEdit" className={`${classInput} ${classInputDark}`} type="text" placeholder=' ' autoComplete="off" value={qtd} onChange={qtdChange} />
                            <label htmlFor="qtdEdit" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Qtd</label>
                        </div>

                        <div className={`relative col-span-4`}>
                            <input id="precoUnitEdit" className={`${classInput} ${classInputDark}`} type="text" placeholder=' ' autoComplete="off" value={precoUnit} onChange={precoUnitChange} />
                            <label htmlFor="precoUnitEdit" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Preço Unit.</label>
                        </div>

                        <div className={`relative col-span-4`}>
                            <input id="totalEdit" className={`${classInput} ${classInputDark} cursor-not-allowed`} type="text" placeholder=' ' autoComplete="off" value={precoTotal} disabled={true} readOnly />
                            <label htmlFor="totalEdit" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Total</label>
                        </div>

                        <div className={`relative col-span-12`}>
                            <input id="ObservacaoEdit" className={`${classInput} ${classInputDark}`} type="text" placeholder=' ' autoComplete="off" value={obsItem} onChange={obsChange} />
                            <label htmlFor="ObservacaoEdit" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação do Item</label>
                        </div>

                    </div>

                </div>

                {loading &&

                    <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 bg-slate-300 dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-start bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-2 rounded-b-lg space-x-3`}>

                    <div className={`flex justify-end items-center w-full space-x-3`}>

                        <button
                            onClick={closeModalEvent} disabled={loading}
                            className={`${classbtColunasVermelho} max-w-[150px]`}>
                            CANCELAR
                        </button>

                        <button
                            onClick={salvarVendaItem}
                            className={`${classbtAzul} ${classBt} max-w-[150px] mx-1`}  >
                            {loading &&
                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                </div>
                            }
                            {!loading ? `FINALIZAR` : `AGUARDE`}

                        </button>

                    </div>

                </div>

            </div>

        </div>

    )
})